import { memo, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import { PhotoCameraIcon, UploadIcon } from '../../../../components/Icons'
import { useTwinPreview } from '../../../../hooks/storeHooks/useTwin'

const UpdateSelfie: React.FC = memo(() => {
  const navigate = useNavigate()

  const {
    setPreviewTabName,
    setPreviewUrl,
    setStyledOriginUrls,
    setSelectedImageStyle,
  } = useTwinPreview()

  const handleStartCamera = () => {
    setPreviewUrl('')
    setStyledOriginUrls({})
    setSelectedImageStyle('')
    setPreviewTabName('camera')
    navigate('/generate-twin/selfie')
  }

  const handleSetPreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]

    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        const imageUrl = reader.result as string
        setPreviewUrl(imageUrl)
        setStyledOriginUrls({})
        setSelectedImageStyle('')
        setPreviewTabName('')
      }
      reader.readAsDataURL(file)
    }
    navigate('/generate-twin/selfie')
  }

  useEffect(() => {
    if (window.webkit?.messageHandlers?.appBridge) {
      const payload = {
        action: 'files/filter',
        source: ['image/jpeg', 'image/png', 'image/webp'],
        allowsMultipleSelection: true,
      }
      window.webkit.messageHandlers.appBridge.postMessage(payload)
    } else {
      console.warn('Native bridge not available (not running in the app?)')
    }
  }, [])

  return (
    <>
      <button
        data-testid="default-selfie-take-btn"
        className="btn btn-primary sm:!grow-0 !grow"
        onClick={handleStartCamera}
      >
        <PhotoCameraIcon size={16} />
        <span className="ml-2">Take a Selfie</span>
      </button>
      <label
        data-testid="default-selfie-upload-btn"
        className="btn btn-primary sm:!grow-0 !grow"
        htmlFor="img-field"
      >
        <input
          type="file"
          accept="image/*"
          id="img-field"
          className="pointer-events-none opacity-0 hidden"
          onChange={handleSetPreview}
        />
        <UploadIcon size={16} />
        <span className="ml-2">Upload a Photo</span>
      </label>
    </>
  )
})

export { UpdateSelfie }
